export default __webpack_public_path__ + "static/media/Montserrat-Bold.bad41f06.woff2";